module.exports = __webpack_public_path__ + "static/media/delivery-icon.916d1345.svg";